/**
 * Link de rastreio do envio, para o cliente e para a equipe.
 *
 * Código no padrão dos Correios (2 letras, 9 dígitos, "BR") abre direto no site dos
 * Correios. Os demais (Jadlog, Loggi, Azul Cargo e os códigos do Melhor Envio) abrem no
 * Melhor Rastreio, que reconhece a transportadora pelo próprio código.
 */
const CORREIOS_CODE = /^[A-Z]{2}\d{9}[A-Z]{2}$/;
export function buildTrackingUrl(trackingCode) {
    const code = (trackingCode ?? '').trim().toUpperCase().replace(/\s+/g, '');
    if (!code)
        return null;
    if (CORREIOS_CODE.test(code)) {
        return `https://rastreamento.correios.com.br/app/index.php?objetos=${encodeURIComponent(code)}`;
    }
    return `https://www.melhorrastreio.com.br/rastreio/${encodeURIComponent(code)}`;
}
//# sourceMappingURL=tracking-url.js.map